<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Выберите события</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <template v-if="events">
          <table class="px-0">
            <tr v-for="event in (availableEvents ? availableEvents : events)">
              <td style="display:none;">
                <div class="btn-group-toggle">
                  <label class="notification-channel-btn btn btn-link btn-sm" :class="{active: smsOn(event)}">
                    <input type="checkbox" autocomplete="off" :value="event" v-model="sms">
                    <font-awesome-icon icon="comment-alt" />
                    SMS
                  </label>
                </div>
              </td>
              <td>
                <div class="btn-group-toggle">
                  <label class="notification-channel-btn btn btn-link btn-sm" :class="{active: emailOn(event)}">
                    <input type="checkbox" autocomplete="off" :value="event" v-model="email">
                    <font-awesome-icon icon="at" />
                    EMAIL
                  </label>
                </div>
              </td>
              <td class="pl-2" :class="anyOn(event) ? 'font-weight-bold' : 'text-muted'">{{ formatLabel(event) }}</td>
            </tr>
          </table>
        </template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="save">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
  import sortBy from 'lodash/sortBy'
  import events from '../lang/events.json'

  export default {
    props: ['value', 'available'],
    data () {
      return {
        events: sortBy(Object.keys(events), (key) => events[key]),
        sms: [],
        email: [],
      }
    },
    created () {
      this.sms = this.value.map((current) => current.send_sms ? current.event_code : null).filter(a => a)
      this.email = this.value.map((current) => current.send_email ? current.event_code : null).filter(a => a)
    },
    methods: {
      save () {
        this.$emit('hide', this.sms.concat(this.email.filter((item) => {
          return this.sms.indexOf(item) < 0
        })).map((current) => {
          return {
            event_code: current,
            send_sms: this.sms.includes(current),
            send_email: this.email.includes(current),
          }
        }))
      },
      smsOn (event) {
        return this.sms.indexOf(event) !== -1
      },
      emailOn (event) {
        return this.email.indexOf(event) !== -1
      },
      anyOn (event) {
        return this.smsOn(event) || this.emailOn(event)
      },
      formatLabel (event) {
        return events[event].split('|')[0]
      },
    },
    computed: {
      availableEvents () {
        return sortBy(this.available, (key) => events[key])
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .notification-channel-btn {
    text-decoration: none !important;
    color: $gray-400;
    text-transform: uppercase;
    letter-spacing: .06em;
    font-weight: $font-weight-bold;
    &:hover, &:focus {
      color: $gray-600;
      background: $gray-200;
    }
    &:active {
      border-color: $primary !important;
      background: $white;
    }
    &.active {
      border-color: $primary !important;
      color: $primary !important;
      background: $white !important;
      box-shadow: 0 0 4px rgba($primary, .3) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/event-modal.vue